import React from "react";
import get from "lodash/get";
import { withTranslation } from "react-i18next";
import Modal from "../modal";
import ImageUploadInput from "../inputs/image-upload";
import generateAvatarSVG from "../../utils/generate-avatar-svg";
import { RillContext } from "../../rill/RillReact/share/base";

class EditCycleModal extends React.Component {
  handleCycleTypeChange() {
    document.getElementById("add-cycle-form").reset();
  }

  render() {
    const { t } = this.props;
    const {
      locals: { query, activeCycles, editCycle, activeUser, athlete },
    } = this.context;
    const { _id, description, image } = editCycle;
    const [firstName, lastName] = get(editCycle, "createdBy.name", "").split(
      / +/
    );
    const isAdmin = activeUser.hasRole("admin");
    return (
      <form
        id="add-cycle-form"
        action={`/actions/cycle/edit/${editCycle._id}?athlete=${
          athlete && athlete._id
        }`}
        method="POST"
        encType="multipart/form-data"
        data-noreset
        noValidate
      >
        <input type="hidden" name="_id" value={_id} />
        <Modal>
          <div className="head">
            <h2 className="alt">{t("editCycle.title")}</h2>
          </div>

          <div className="body">
            <div className="Add-Cycle">
              <div className="group">
                <div className="label">{t("editCycle.cycleName")}</div>
                <input
                  name="name"
                  className="text-input"
                  defaultValue={editCycle.name}
                />
              </div>

              <div className="group">
                <div className="label">{t("editCycle.description")}</div>
                <textarea
                  name="description"
                  className="textarea-input"
                  defaultValue={editCycle.description}
                ></textarea>
              </div>

              <div className="group alt-rm">
                <div className="label">{t("editCycle.photo")}</div>
                <ImageUploadInput
                  name="image"
                  defaultValue={
                    editCycle.image || generateAvatarSVG(firstName, lastName)
                  }
                  required
                />
              </div>

              {isAdmin && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/2">
                      <div className="label">{t("editCycle.type")}</div>
                      <select
                        name="type"
                        className="select-input"
                        defaultValue={editCycle.type || "user"}
                      >
                        <option value="premium">{t("editCycle.premium")}</option>
                        <option value="standard">{t("editCycle.standard")}</option>
                        <option value="user">{t("editCycle.user")}</option>
                        <option value="coach">{t("editCycle.coach")}</option>
                      </select>
                    </div>
                    <div className="column" data-col="1/2">
                      <div className="label">{t("editCycle.status")}</div>
                      <select
                        name="status"
                        className="select-input"
                        defaultValue={editCycle.status || "draft"}
                      >
                        <option value="published">{t("editCycle.published")}</option>
                        <option value="created">{t("editCycle.created")}</option>
                        <option value="archived">{t("editCycle.archived")}</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="foot">
            <div className="columns">
              <div className="column" data-col="1/3">
                <a className="button alt" href="/actions/refresh?modal=">
                  {t("common:cancel")}
                </a>
              </div>

              <div
                className="column"
                data-col="1/3"
                style={{ textAlign: "center" }}
              ></div>

              <div
                className="column mobile-hidden"
                data-col="1/3"
                style={{ textAlign: "right" }}
              >
                <button type="submit" className="button-input">
                  {t("common:save")}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

EditCycleModal.contextType = RillContext;

export default withTranslation("coaching-portal")(EditCycleModal);
